module.exports = __webpack_public_path__ + "img/03_Button.5b00522e.png";